import { SET_USER_DETAILS, SET_USER, CLEAR_REDUX } from '../actionTypes';

const initialState = {
    userDetails: "",
    user: ""
}

export const setUserDetailsReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_USER_DETAILS:
            return {
                ...state,
                userDetails: { ...state.userDetails, ...action.payload }
            };
        case SET_USER:
            return {
                ...state,
                user: action.payload
            };
        case CLEAR_REDUX:
            return initialState;
        default:
            return state;
    }
}